import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import HelpForm from "./HelpForm";

class Help extends Component {
  static contextType = AuthContext;

  cobrowseSupportCode() {
    return (
      <div>
        {" "}
        <button
                type={"submit"}
                className="k-button k-button-md k-button-solid k-button-solid-primary k-rounded-md"
                onClick={window["showSessionCode"]}
              >
          <span class="k-button-text">
                Generate a Support Code
          </span>
        </button>       
      </div>
    );
  }

  render() {
    
      return (        
        <div className="page-wrapper"> 
          <div className="panelbar-wrapper">
              <HelpForm></HelpForm>  
          </div>
          <div className="panelbar-wrapper">
            {this.cobrowseSupportCode()}
          </div>
         
        </div>
        
      )
}
}

export default withRouter(Help);
